module.exports = __webpack_public_path__ + "img/dingding_sys_img.58fa6ba.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/web/home/dingding_sys_img.png
// module id = fB2H
// module chunks = 1 87 131